import { gql } from "@apollo/client";

export const SIGNUP_MUTATION = gql`
  mutation signUpMutation($email: String!, $password: String!, $firstName: String!, $lastName: String!, $phoneNumber: String!, $country: String!) {
    signup(createUserInput: { email: $email, password: $password, firstName: $firstName, lastName: $lastName, phoneNumber: $phoneNumber, country: $country }){
      message
      statusCode
      success
    }
  }
`;
export const SUBMIT_PROPERTY_MUTATION = gql`
  mutation SubmitPropertyMutation($submitPropertyInput: SubmitPropertyRequestDTO!) {
    submitProperty(submitPropertyInput: $submitPropertyInput) {
      message
      statusCode
      success
    }
  }
`
export const SUBMIT_QUESTIONNAIRE_MUTATION = gql`
  mutation SubmitQuestionaireMutation($desiredPropertyClasses: [PropertyClassEnum!]!,$desiredPropertyTypes: [PropertyTypeEnum!]!,$investorInstitution: InvestorInstitutionEnum!,$investorType: InvestorTypeEnum!,$realEstateOwned: String!,$riskTolerance: RiskToleranceEnum!) {
    submitQuestionaire(submitQuestionaireInput: {desiredPropertyClasses:$desiredPropertyClasses,desiredPropertyTypes:$desiredPropertyTypes,investorInstitution:$investorInstitution,investorType: $investorType,realEstateOwned:$realEstateOwned,riskTolerance: $riskTolerance}) {
      message
      statusCode
      success
    }
  }
`;
export const CHANGE_PASSWORD_MUTATION = gql`
  mutation changePasswordMutation($currentPassword: String!,$newPassword: String!) {
    changePassword(changePassword: {currentPassword: $currentPassword,newPassword: $newPassword}){
      message
      statusCode
      success
    }
  }
`;
export const UPDATE_PROFILE_DATA_MUTATION = gql`
mutation updateProfileDataMutation($firstName: String, $lastName: String,$profileImage:String) {
  updateProfileData(updateProfileData: { firstName: $firstName, lastName: $lastName,profileImage: $profileImage }){
    message
    statusCode
    success
  }
}
`;

export const OTP_MUTATION = gql`
  mutation otpMutation($email: String!,$otp: String!) {
    verifyPasswordResetOTP(verifyPasswordResetOTPInput: {OTP: $otp,email:$email}) {
      message
      statusCode
      success
    }
  }
`
export const FORGOT_PASSWORD_MUTATION = gql`
  mutation forgotPasswordMutation($email: String!,$OTP: String!,$newPassword: String!) {
    resetPassword(resetPasswordInput: {email: $email,OTP: $OTP,newPassword: $newPassword}) {
      message
      statusCode
      success
    }
  }
`
export const CONTACT_US = gql`
mutation contact($firstName: String!,$lastName: String!,$email: String!,$subject: String!,$message: String!){
    sendContactUsEmail(sendContactUsEmailInput: { firstName: $firstName, lastName:$lastName,email: $email, subject:$subject,message:$message}){
      message
      statusCode
      success
    }
    
  }
`
export const FORGOT_PASSWORD = gql`
mutation forgotPassword($email: String!){
    initiateResetPassword(initiateResetPasswordInput: {email: $email}){
      statusCode
      message
      success
    }
  }
`;

export const ADD_FAVORITE_PROPERTY = gql`
  mutation AddFavoriteProperty($addFavoritePropertyInput: PropertyRequestDTO!) {
    addFavoriteProperty(addFavoritePropertyInput: $addFavoritePropertyInput) {
      message
      statusCode
      success
    }
  }
`;

export const REMOVE_FAVORITE_PROPERTY = gql`
  mutation RemoveFavoriteProperty($removeFavoritePropertyInput: PropertyRequestDTO!){
    removeFavoriteProperty(removeFavoritePropertyInput: $removeFavoritePropertyInput){
      message
      statusCode
      success
    }
  }
`;

export const SHOW_INTEREST_IN_PROPERTY = gql`
  mutation ShowInterestInProperty($showInterestInPropertyInput: ExpressInterestRequestDTO!) {
    showInterestInProperty(showInterestInPropertyInput: $showInterestInPropertyInput) {
      message
      statusCode
      success
    }
  }
`;